<template>
	<div>
	<div class="row">
		<div class="panel panel-primary">
			<div class="panel-heading">
				<span class="h4">{{ title }}</span>
				<span class="pull-right">{{ recordCount }} of {{ totalCount }} Displayed</span>
			</div>
			<table class="table table-bordered">
				<thead>
					<tr>
						<th class="row-actions row-actions-2-btn" v-if="actionsComponent">&nbsp;</th>
						<th v-for="heading in headings" :class="heading.customClasses">{{ heading.heading }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="isLoading"><td :colspan="headings.length + 1" class="text-center"><strong>Loading...</strong></td></tr>
					<tr v-else v-for="row in data">
						<td class="row-actions row-actions-2-btn" v-if="actionsComponent">
							<component :is="actionsComponent" v-on:input="emitEvent" :data="row" :config="actionsConfig" />
						</td>

						<td v-for="column in columns" :class="column.customClasses">
							<component v-if="column.component" :is="column.component" :value="row[column.column]" :config="{}" />
							<span v-else-if="column.html" v-html="formatData(row[column.column], column.column)"></span>
							<span v-else>{{ formatData(row[column.column], column.column) }}</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="panel-footer" v-if="footers.length > 0">
				&nbsp;
			</div>
		</div>
	</div>
		<div class="row">
			<pagination :links="meta.links" v-if="links.prev != null || links.next != null" v-on:page-nav="$emit('page-nav', $event)" />
		</div>
	</div>
</template>
<script>

import Pagination from "../display/Pagination.vue";

export default {
	components: {Pagination},
	props: {
		customClass: {
			type: String,
			default: ''
		},
		striped: {
			type: Boolean,
			default: true
		},
		condensed: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			required: true
		},
		headings: {
			type: Array,
			default: [],
		},
		footers: {
			type: Array,
			default: []
		},
		columns: {
			type: Array,
			default: []
		},
		data: {
			type: Array,
			default: [],
		},
		meta: {
			type: Object,
			required: false,
			default: null
		},
		links: {
			type: Object,
			default: {}
		},
		actionsComponent: {
			type: Object,
			default: null
		},
		actionsConfig: {
			type: Object,
			default: () => {}
		},
		formatters: {
			type: Object,
			required: false,
			default: () => {}
		},
		isLoading: {
			type: Boolean,
			default: true,
		}
		
	},
	computed: {
		recordCount() {
			return this.data.length
		},
		totalCount() {
			return this.meta?.total ?? this.data.length
		}
	},
	methods: {
		emitEvent(event) {
			console.log('emitEvent', event)
			this.$emit(event.event, event.data);
		},
		formatData(value, column) {
			if (this.formatters && column in this.formatters && typeof this.formatters[column] === 'object') {
				return this.formatters[column].callback(value)
			}
			return value
			
		}
	}
}
</script>
